var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingSection6Togo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-double-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37078 2.94951C6.68936 2.63092 7.20589 2.63092 7.52448 2.94951L17.3139 12.739C17.6325 13.0576 17.6325 13.5741 17.3139 13.8927L7.52448 23.6822C7.20589 24.0007 6.68936 24.0007 6.37078 23.6822C6.05219 23.3636 6.05219 22.847 6.37078 22.5285L15.5834 13.3158L6.37078 4.10321C6.05219 3.78463 6.05219 3.2681 6.37078 2.94951Z",
    fill: "#42D09F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8971 2.94951C13.2157 2.63092 13.7323 2.63092 14.0508 2.94951L23.8403 12.739C24.1589 13.0576 24.1589 13.5741 23.8403 13.8927L14.0508 23.6822C13.7323 24.0007 13.2157 24.0007 12.8971 23.6822C12.5786 23.3636 12.5786 22.847 12.8971 22.5285L22.1098 13.3158L12.8971 4.10321C12.5786 3.78463 12.5786 3.2681 12.8971 2.94951Z",
    fill: "#42D09F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSection6Togo);
export default __webpack_public_path__ + "static/media/LandingSection6Togo.c4bce65469aea01e931edebf52f6a302.svg";
export { ForwardRef as ReactComponent };